import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const getSAProfileDetails = (request) => {
    let profileId = request.data;
    const ENDPOINT = URL_BASE_API+'user/admin-profile/'+profileId;
    return service.get(ENDPOINT);  
}; 

export const updateSAProfileDetails = (request) => {
    let profileId = request.data.get('id');
    const ENDPOINT = URL_BASE_API+'user/admin-profile/'+profileId;
    return service.put(ENDPOINT,request.data);  
}; 

